import { useEffect, useRef } from 'react'
import { debounce } from 'lodash'

const useInactivityLogout = (timeout = 1800000, actionCallback) => {
  const idleTimerRef = useRef(null)
  const logout = () => {
    // Log out user or perform other actions
    actionCallback?.()
  }

  useEffect(() => {
    const resetTimer = () => {
      clearTimeout(idleTimerRef.current)
      idleTimerRef.current = setTimeout(logout, timeout)
    }
    const debouncedResetTimer = debounce(resetTimer, 500)

    window.addEventListener('mousemove', debouncedResetTimer)
    window.addEventListener('keydown', debouncedResetTimer)
    window.addEventListener('scroll', debouncedResetTimer)

    resetTimer()

    return () => {
      clearTimeout(idleTimerRef.current)
      window.removeEventListener('mousemove', debouncedResetTimer)
      window.removeEventListener('keydown', debouncedResetTimer)
      window.removeEventListener('scroll', debouncedResetTimer)
      debouncedResetTimer.cancel()
    }
  }, [timeout, actionCallback])

  return null
}

export default useInactivityLogout
